
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export const HeroButtons = () => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center w-full max-w-md sm:max-w-none mx-auto">
      {/* Primary CTA - Modern Design */}
      <button 
        className="btn-cta btn-xl group relative overflow-hidden mobile-btn-lg touch-target-lg w-full sm:w-auto"
        onClick={() => window.open('https://calendly.com/david-scienzahealth/product-demo', '_blank')}
      >
        <span className="relative z-10 flex items-center justify-center">
          Book Demo
          <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 transition-transform group-hover:translate-x-1" />
        </span>
      </button>
      
      {/* Secondary CTA */}
      <Link to="/how-it-works" className="w-full sm:w-auto">
        <button className="btn-outline btn-xl w-full">
          See How It Works
        </button>
      </Link>
    </div>
  );
};
